const faqs = [
  {
    q: '51cg吃瓜网的内容多久更新一次？',
    a: '我们坚持每日更新，51吃瓜官网全网最新团队全天候监测娱乐动态，确保第一时间发布最新爆料与热门事件。通常每天更新80条以上内容，重大事件发生时实时跟进。',
  },
  {
    q: '如何向51吃瓜网投稿爆料？',
    a: '欢迎通过页面底部的爆料投稿渠道联系我们，支持邮件和微信两种方式。投稿信息将被严格保密，内容一经采纳即付稿酬。我们鼓励提供真实、有料的独家消息。',
  },
  {
    q: '51今日吃瓜的内容来源可靠吗？',
    a: '所有51cg吃瓜最新爆料内容均经过多源交叉验证和编辑团队审核。我们设有严格的信息把关机制，对无法核实的内容会明确标注，确保吃瓜群众获取的信息真实可信。',
  },
  {
    q: '移动端和网页版有什么区别？',
    a: '移动端提供推送提醒、离线阅读和夜间模式等专属功能，浏览体验更加流畅。网页版则适合深度阅读和内容搜索。两者内容同步更新，可根据使用场景自由选择。',
  },
  {
    q: '51cg吃瓜热门事件的标准是什么？',
    a: '热门事件标签基于全网讨论热度、话题持续度与用户关注度综合评定。我们的编辑团队结合各大社交平台数据，每日更新51cg吃瓜今日更新榜单，确保热门内容反映真实舆论走向。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3" style={{ fontFamily: 'var(--font-heading)' }}>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center mt-0.5">
                  <span className="text-accent-600 text-sm font-bold">Q</span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}